// collection-header-logo-bridge.js
// Coordinates between the collection header scroll behavior and the original logo-switcher.js

document.addEventListener('DOMContentLoaded', function() {
  initCollectionLogoCoordination();
  
  // In case of dynamic section loads (Shopify)
  document.addEventListener('shopify:section:load', function() {
    initCollectionLogoCoordination();
  });
});

function initCollectionLogoCoordination() {
  // Check if we're on a collection page
  const isCollectionPage = document.body.classList.contains('template-collection');
  
  if (!isCollectionPage) return;
  
  // Create a custom event to notify the existing logo-switcher that we've changed the logo
  const logoSwitchEvent = new CustomEvent('collection-logo-switch');
  
  // Get references to the DOM elements
  const headerWrapper = document.querySelector('.header-wrapper');
  const whiteLogos = document.querySelectorAll('.header__heading-logo--white');
  const blackLogos = document.querySelectorAll('.header__heading-logo--black');
  
  if (!headerWrapper || !whiteLogos.length || !blackLogos.length) return;
  
  // Mark logos to prevent default filter application from original script
  [...whiteLogos, ...blackLogos].forEach(logo => {
    logo.setAttribute('data-preserve-logo-color', 'true');
  });
  
  // Function to update logo visibility based on header state
  function updateLogoVisibility() {
    const isScrolled = headerWrapper.classList.contains('scrolled-header');
    const isDrawerOpen = headerWrapper.classList.contains('drawer-open');
    const isMegaMenuOpen = headerWrapper.classList.contains('mega-menu--open');
    
    // Drawer open or mega menu open always shows black logo (takes precedence)
    if (isDrawerOpen || isMegaMenuOpen) {
      whiteLogos.forEach(logo => logo.style.display = 'none');
      blackLogos.forEach(logo => logo.style.display = 'block');
    } 
    // When scrolled, show black logo
    else if (isScrolled) {
      whiteLogos.forEach(logo => logo.style.display = 'none');
      blackLogos.forEach(logo => logo.style.display = 'block');
    } 
    // Otherwise (transparent header), show white logo
    else {
      whiteLogos.forEach(logo => logo.style.display = 'block');
      blackLogos.forEach(logo => logo.style.display = 'none');
    }
    
    // Dispatch event for coordination with other scripts
    document.dispatchEvent(logoSwitchEvent);
  }
  
  // Observe the scrolled-header class being added/removed
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.attributeName === 'class') {
        updateLogoVisibility();
      }
    });
  });
  
  observer.observe(headerWrapper, { attributes: true });
  
  // Watch specifically for the mobile menu drawer
  const menuDrawerDetails = document.querySelector('#Details-menu-drawer-container');
  if (menuDrawerDetails) {
    menuDrawerDetails.addEventListener('click', function() {
      // Short timeout to allow class changes to be applied
      setTimeout(updateLogoVisibility, 50);
    });
    
    // Also observe the details element directly
    const drawerObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'open') {
          updateLogoVisibility();
        }
      });
    });
    
    drawerObserver.observe(menuDrawerDetails, { attributes: true });
  }
  
  // Run once on page load to set initial state
  updateLogoVisibility();
} 